module.exports = __webpack_public_path__ + "static/media/Valerie.d57211bb.jpg";